/** Compact renderer for engine warnings (materialisation / propagation / manage). */
import { Typography } from '@mui/material';

import type { TemplateWarning } from '@/api/rbac';
import { ValueActions } from '@/components/ValueActions/ValueActions';
import { accessGroupIdActions } from '@/features/users/userLinks';

export function WarningList({ warnings }: { warnings: TemplateWarning[] }) {
  if (!warnings.length) return null;
  return (
    <>
      {warnings.map((w, i) => (
        // Positional keys: the list is static per render (one engine result).
        // eslint-disable-next-line react/no-array-index-key
        <Typography key={i} variant="body2" sx={{ mt: 0.5 }}>
          <code>{w.code}</code> — {w.message}
          {/* The group the engine is complaining about — without a link the
              reader has to search the grid for it by hand. The template id
              has no page of its own (templates are dialog-edited with no
              ?edit= intent), so it is deliberately not linked. */}
          {w.agroup_id !== null && (
            <>
              {' '}
              <ValueActions actions={accessGroupIdActions(w.agroup_id)}>
                {`group #${w.agroup_id}`}
              </ValueActions>
            </>
          )}
        </Typography>
      ))}
    </>
  );
}
